import { cn } from '../../lib/utils';

export interface RecommendedLength {
	min: number;
	max: number;
}

/** Strip HTML tags to get plain text length. */
function stripHtmlLength(value: string): number {
	return value.replace(/<[^>]*>/g, '').replace(/&[^;]+;/g, ' ').length;
}

export function CharacterCount(props: { value: string; recommended: RecommendedLength; isHtml?: boolean }) {
	const count = props.isHtml ? stripHtmlLength(props.value) : props.value.length;
	const isUnder = count < props.recommended.min;
	const isOver = count > props.recommended.max;
	const isInRange = !isUnder && !isOver;

	return (
		<p
			className={cn(
				'm-2 text-xs',
				isInRange ? 'text-emerald-600' : isOver ? 'text-destructive' : 'text-muted-foreground',
			)}
		>
			{count}/{props.recommended.min}-{props.recommended.max} characters
		</p>
	);
}
